<template>
    <header class="content__header">
        <h2 class="content__title">
            {{ title }}
            <span v-if="showStorageStatistics" class="text-tooltip has-tooltip" style="font-size:14px;">
                <a :href="storageStatisticsUri" target="_blank">
                    {{ $t('words.vod_storage_statistics') }}
                </a>
            </span>
        </h2>
        <div class="content__header__action">
            <a v-if="haveSubmitRight" class="btn btn__primary" @click="showRegisterModal">
                <Spinner v-if="isUploading"/>
                <i v-else class="icon icon-sm icon-add"></i>
                <span>{{ fileRegisterNameByTotalProgress }}</span>
            </a>
        </div>
    </header>
</template>

<script>
import GlobalConfigMixin from '@/components/mixin/GlobalConfigMixin';
import Spinner from '@/components/cms/common/Animation/Spinner';

export default {
    name: 'MediaContentsHeader',
    components: { Spinner },
    mixins: [
        GlobalConfigMixin,
    ],
    props: {
        title: {
            type: String,
            default: '',
        },
        showStorageStatistics: {
            type: Boolean,
            default: false,
        },
        fileRegisterName: {
            type: String,
            default: '',
        },
        totalProgress: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        haveSubmitRight() {
            return this.haveOwnerRight;
        },
        storageStatisticsUri() {
            if (this.getConfig && 'vod_console_uri' in this.getConfig) {
                return `${this.getConfig.vod_console_uri}media/analytics/stats/storage`;
            }
            return '';
        },
        fileRegisterNameByTotalProgress() {
            return !this.isUploading ? this.fileRegisterName : this.$t('words.upload_progress', { progress: this.totalProgress });
        },
        isUploading() {
            return this.totalProgress !== null && this.totalProgress < 100;
        },
    },
    methods: {
        showRegisterModal() {
            this.$emit('showRegisterModal');
        },
    },
};
</script>
